import { useEffect, useState } from "react";
import { asyncVoid } from "lib/errors/asyncVoidHandler";

type UseCountdownOptions = {
  onComplete: () => Promise<void>;
  seconds: number;
};

export default function useCountdown({
  onComplete,
  seconds,
}: UseCountdownOptions) {
  const [secondsRemaining, setSecondsRemaining] = useState(seconds);

  useEffect(() => {
    if (secondsRemaining === 0) {
      asyncVoid(onComplete());
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setSecondsRemaining(
        (currentSecondsRemaining) => currentSecondsRemaining - 1,
      );
    }, 1000);

    return () => window.clearTimeout(timeoutId);
  }, [onComplete, secondsRemaining]);

  return secondsRemaining;
}
